import {Grid, GridProps} from '@chakra-ui/react'

interface Props extends GridProps {
  repeatCount?: number | 'auto-fit' | 'auto-fill'
  /**
   * @default 'auto'
   */
  minColumnWidth?: string
  /**
   * @default '16rem'
   */
  maxColumnWidth?: string
}

export function FormGrid({
  repeatCount = 'auto-fit',
  minColumnWidth = 'auto',
  maxColumnWidth = '16rem',
  ...props
}: Props) {
  return (
    <Grid
      gridTemplateColumns={{base: '1fr', md: `repeat(${repeatCount}, minmax(${minColumnWidth}, ${maxColumnWidth}))`}}
      gapX="4"
      gapY="4"
      {...props}
    >
      {props.children}
    </Grid>
  )
}
